import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgWebsite } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";
import { FaFigma } from "react-icons/fa";
function ProjectCards(props) {
  return (
    <div id="projects-section">
<Card className="project-card-view" id="projects">
      <Card.Img variant="top" src={props.imgPath} alt="card-img" />
      <Card.Body>
        <Card.Title>{props.title}</Card.Title>
        <Card.Text style={{ textAlign: "justify" }}>
          {props.description}
        </Card.Text>
        {/* If the component contains Demo link and if it's not a Blog then, it will render the below component  */}
        {!props.isBlog && props.demoLink && (
          <Button
            variant="primary"
            href={props.demoLink}
            target="_blank"
            style={{ marginLeft: "10px" }}
          >
            <CgWebsite /> &nbsp;
            {"Demo"}
          </Button>
        )}
        {!props.isBlog && props.FigmaLink && (
          <Button
            variant="primary"
            href={props.FigmaLink}
            target="_blank"
            style={{ marginLeft: "10px" }}
          >
            <FaFigma /> &nbsp;
            {"Figma"}
          </Button>
        )}
        {!props.isBlog && props.ghLink && (
          <Button
            variant="primary"
            href={props.ghLink}
            target="_blank"
            style={{ marginLeft: "10px" }}
          >
            <BsGithub /> &nbsp;
            {"GitHub"}
          </Button>
        )}
      </Card.Body>
    </Card>
    </div>
    
  );
}
export default ProjectCards;
